import { Pipe, PipeTransform } from '@angular/core';
import { Asset } from '@zero/shared/util-models';

@Pipe({
  name: 'isKnockedOut',
  standalone: true,
})
export class IsKnockedOutPipe implements PipeTransform {
  public transform = (asset: Asset): boolean => Boolean(asset?.knockedOutFlag);
}
